<template>
  <div class="personal-centerEn-page main-container">
    <v-topBarEn></v-topBarEn>
    <v-publicBanner :bannerInfo="bannerInfo"></v-publicBanner>
    <div class="public-banner-bot-comtent clearfix">
      <div class="left-wraper pull-left">
        <ul>
          <li :class="activeName == item.name ? 'active' : ''"
              @click="toggeleActiveName(item)"
              v-for="(item, index) in meunList"
              :key="index">{{ item.label }}</li>
        </ul>
      </div>
      <div class="right-wraper">
        <!--   后期加了组件 加v-show判断就好     -->
        <v-updatePassword></v-updatePassword>
      </div>
    </div>
  </div>
</template>
<script>
  import topBarEn from '@/components/topBarEn'
  import publicBanner from '@/components/publicBanner'
  import updatePassword from '@/components/personalCenterEn/updatePassword'
  export default {
    data () {
      return {
        bannerInfo: {
          title: 'Personal Center',
          content: ""
        },
        activeName: 'updatePassword',  //当前展示菜单
        meunList: [  // 菜单列表
          {
            label: 'Update Password',
            path: '',
            name: 'updatePassword'
          }
        ],

      }
    },
    components: {
      'v-topBarEn': topBarEn,
      'v-publicBanner': publicBanner,
      'v-updatePassword': updatePassword
    },
    created () {
    },
    methods:{
      toggeleActiveName (item) {
        this.activeName = item.name
      }
    }
  }
</script>

<style lang="stylus">
  .personal-centerEn-page {
    background-color: #f5f6fa;
    min-height: 100vh;
    .publicBanner {
      background: url(https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/personal_banner.png) no-repeat top;
    }
    .public-banner-bot-comtent{
      overflow: hidden;
      margin-bottom: 0;
      padding-bottom: 0;
    }
    .personal-center-title{
      h3{
        font-size: 30px;
        color: #303133;
        line-height: 30px;
        padding-bottom: 32px;
        border-bottom: 1px solid #e8ecf2;
      }
    }
    .left-wraper{
      width: 240px;
      height: 760px;
      background: #F5F6FA;
      box-sizing: border-box;
      padding: 32px 0 32px 32px;
      li{
        height: 48px
        line-height: 48px;
        padding: 0 16px 0 24px;
        color: #303133;
        border-left: 2px solid transparent;
        border-radius: 0;
        border-bottom: 1px solid #e8ecf2;
        box-sizing: border-box;
        font-size: 14px;
        cursor: pointer;
        &:hover{
          background-color: #e8ecf2;
        }
        &.active{
          background: #fff;
          color: #3f88e0;
          border-color: #65a0e6;
          margin-right: -1px;
          border-bottom: 1px solid #e8ecf2;
          font-weight: 700;
        }
      }
    }
    .right-wraper{
      min-width: 920px;
      height: 760px;
      background-color: #fff;
      margin-left: 240px;
      padding: 0 48px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/personalCenterEn/index.vue